// extracted by mini-css-extract-plugin
export default {"landingSection":"LandingPage_landingSection__Iq1uE","content":"LandingPage_content__MUjk9","ctaDiv":"LandingPage_ctaDiv__EN-lp","btnPrimary":"LandingPage_btnPrimary__3NvMs"};